import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { turboFrameId: String }

  connect() {
    if (this.turboFrameIdValue) {
      this.element.addEventListener("turbo:before-fetch-request", this.setTurboFrameHeader.bind(this))
    }
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.setTurboFrameHeader.bind(this))
  }

  setTurboFrameHeader(event) {
    event.detail.fetchOptions.headers = event.detail.fetchOptions.headers || {}
    event.detail.fetchOptions.headers["Turbo-Frame"] = this.turboFrameIdValue
  }
}
